module.exports = __webpack_public_path__ + "img/Остеоартроз (гонартроз).38e334cd.jpg";